// Sign-in hooks: who is signed in (and at which sign-in step), the password step, the code step and sign-out.
// Every answer refreshes the session, so the sign-in screen follows the stage by itself.
import { useQuery } from '@tanstack/react-query'
import { useApi } from '@/api/ApiProvider'
import type { SignInInput, VerifyTwoStepInput } from '@/api/schemas'
import { useChange } from '@/api/useChange'

const keys = { session: ['session'] as const }

export function useSession() {
  const api = useApi()
  return useQuery({ queryKey: keys.session, queryFn: () => api.getSession() })
}

export const useSignIn = () => useChange((api, input: SignInInput) => api.signIn(input))
export const useVerifyTwoStep = () => useChange((api, input: VerifyTwoStepInput) => api.verifyTwoStep(input))
export const useSignOut = () => useChange((api, _input: undefined) => api.signOut())
